"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _config = require("@trs/config");
var _radio = require("../../radio");
var _helpers = require("./helpers");
var _PercentageToggler = _interopRequireDefault(require("./PercentageToggler.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var options = [{
  value: _helpers.SEARCHABLE_TYPES.NUMERIC_SIMPLE,
  ariaLabel: 'searchableTypeNumber',
  id: 'searchableTypeNumber',
  textAsIcon: _config.PERCENTAGE_TOGGLER_ICONS.NUMERIC,
  withNativeInput: false
}, {
  value: _helpers.SEARCHABLE_TYPES.NUMERIC_PERCENTAGE,
  ariaLabel: 'searchableTypePercentage',
  id: 'searchableTypePercentage',
  textAsIcon: _config.PERCENTAGE_TOGGLER_ICONS.PERCENTAGE,
  withNativeInput: false
}];
/* remove value from prop - simplify this component - */
var PercentageToggler = /*#__PURE__*/function (_React$PureComponent) {
  function PercentageToggler() {
    _classCallCheck(this, PercentageToggler);
    return _callSuper(this, PercentageToggler, arguments);
  }
  _inherits(PercentageToggler, _React$PureComponent);
  return _createClass(PercentageToggler, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        type = _this$props.type,
        onTypeChange = _this$props.onTypeChange,
        percentageOnly = _this$props.percentageOnly,
        numericOnly = _this$props.numericOnly;
      var data = options;
      if (numericOnly) {
        data = [options[0]];
      } else if (percentageOnly) {
        data = [options[1]];
      }
      return /*#__PURE__*/_react["default"].createElement(_PercentageToggler["default"], {
        className: "searchable-percent-toggle"
      }, /*#__PURE__*/_react["default"].createElement(_radio.RadioGroup, {
        onChange: function onChange(ev) {
          return onTypeChange({
            type: (0, _utils.getEventValue)(ev)
          });
        },
        selectedValue: type,
        disabled: false,
        name: "searchableTypeRadios",
        options: data,
        errors: ""
      }));
    }
  }]);
}(_react["default"].PureComponent);
PercentageToggler.defaultProps = {
  percentageOnly: false,
  numericOnly: false
};
PercentageToggler.propTypes = {
  /* Should we show only percentages? */
  percentageOnly: _propTypes["default"].bool,
  /* Should we show only numeric? */
  numericOnly: _propTypes["default"].bool,
  /* The searchable type, either numeric or percentage */
  type: _propTypes["default"].oneOf(['percentage', 'numeric']).isRequired,
  /* The formula change store action */
  onTypeChange: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = PercentageToggler;